import React from 'react'

import {
  AppWrapper,
  Bullet,
  Button,
  ButtonShape,
  Columns,
  ComponentColor,
  ComponentSize,
  FlexBox,
  FlexDirection,
  FunnelPage,
  Grid,
  IconFont,
  InfluxColors,
  Panel,
} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'
import MarketplaceSubscriptionLink from 'js/components/MarketplaceSubscriptionLink'
import RegisterHeader from './RegisterHeader'
import {Marketplace} from 'js/types/marketplace'

interface Props {
  marketplace: Marketplace
  error?: string
}

const MarketplaceRegistrationError = ({
  marketplace,
  error,
}: Props): JSX.Element => {
  const handleClick = () => {
    window.open(
      'https://v2.docs.influxdata.com/v2.0/cloud/get-started/',
      '_blank'
    )
  }

  return (
    <AppWrapper type="funnel" className="marketplace-splash">
      <FunnelPage logo={<LogoWithCubo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <RegisterHeader marketplace={marketplace} />
            <Panel className="marketplace-splash--panel">
              <Panel.SymbolHeader
                symbol={
                  <Bullet
                    glyph={IconFont.AlertTriangle}
                    color={InfluxColors.Curacao}
                  />
                }
                title={
                  <h5>{error || 'Your Subscription Registration Expired'}</h5>
                }
                size={ComponentSize.Medium}
              />
              <Panel.Body size={ComponentSize.Medium}>
                <FlexBox
                  direction={FlexDirection.Column}
                  margin={ComponentSize.Medium}
                  className="marketplace-splash--buttons"
                >
                  <Button
                    onClick={handleClick}
                    text="See Documentation"
                    size={ComponentSize.Large}
                    color={ComponentColor.Primary}
                    shape={ButtonShape.StretchToFit}
                  />
                  <MarketplaceSubscriptionLink
                    shape={ButtonShape.StretchToFit}
                    marketplace={marketplace}
                    size={ComponentSize.Large}
                    color={ComponentColor.Default}
                  />
                </FlexBox>
              </Panel.Body>
            </Panel>
          </Grid.Column>
        </Grid.Row>
        <p>
          Issues?
          <br />
          Talk to{' '}
          <a href="mailto:support@influxdata.com" target="_blank">
            support@influxdata.com
          </a>
        </p>
      </FunnelPage>
    </AppWrapper>
  )
}

export default MarketplaceRegistrationError
